declare const useDebouncedCallback: <Callback>(
  cb: Callback,
  dependencies: any[],
  debounceMs?: number,
  debounceFn?: <T extends (...args: any[]) => any>(
    callback: T,
    debounceMs: number,
  ) => (...args: Parameters<T>) => unknown,
) => Callback;

export { useDebouncedCallback };
